import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import { ProdIOListQtyCell, ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdIOORetViewRow = (props) => {
    const { formObject, rowKey } = props;

        return (
            <ul className="uiDPEditLine uiTableRowLevel1">
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemId" }} />
                </li>
                <li className="uiColumnLeft uiColumn350">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyReturned1" param2="qtyReturned2" format="#" />
                <li className="uiColumnLeft uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "actionInvType" }} />
                </li>
                <li className="uiColumnLeft uiColumn100">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        useVal={1}
                        action={{ paramName: "actionInvId", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
            </ul>
        )
}

export default ProdIOORetViewRow
